module.exports = __webpack_public_path__ + "img/lets-verify-logo.f68ba88c.svg";